import { render, staticRenderFns } from "./DialogShare.vue?vue&type=template&id=0df6eee0&scoped=true"
import script from "./DialogShare.vue?vue&type=script&lang=js"
export * from "./DialogShare.vue?vue&type=script&lang=js"
import style0 from "./DialogShare.vue?vue&type=style&index=0&id=0df6eee0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df6eee0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0df6eee0')) {
      api.createRecord('0df6eee0', component.options)
    } else {
      api.reload('0df6eee0', component.options)
    }
    module.hot.accept("./DialogShare.vue?vue&type=template&id=0df6eee0&scoped=true", function () {
      api.rerender('0df6eee0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Home/Components/Dialogs/DialogShare.vue"
export default component.exports